export default __webpack_public_path__ + "static/media/arrow_down_blue.4b5e4c7a.svg";